import React from "react";

const NavbarMain = () => {
  return (
    <header className="hisd-header">
      <div className="hisd-header-brand">
        <div className="hisd-header-logo-group">
          <img
            className="hisd-header-logo"
            src="/images/HISDLogoSubmarkWhiteTeal.png"
            alt="HISD"
          />
          <span className="hisd-header-title-divider">|</span>
          <span className="hisd-header-title-name">Transportation</span>
        </div>
        <div className="hisd-header-tagline">Getting Our Students There Safely</div>
      </div>

      <div className="hisd-header-badge">
        <i className="fa-solid fa-shield-alt"></i>
        <span>Safe &bull; Secure &bull; Always Here to Help</span>
      </div>
    </header>
  );
};

export default NavbarMain;
